import React, { FC } from 'react';
import classNames from 'classnames/bind';

import { SkeletonLine } from '../SkeletonPost';

import styles from './SkeletonComment.module.scss';

const cx = classNames.bind(styles);

export const SkeletonComment: FC = () => (
  <div className={cx('skeleton-comment')} data-qa="skeleton-comment">
    <div className={cx('skeleton-comment__details')}>
      <div className={cx('skeleton-comment__avatar')} />
      <div className={cx('skeleton-comment__name')}>
        <SkeletonLine width="80px" />
        <SkeletonLine width="160px" />
      </div>
    </div>
    <div className={cx('skeleton-comment__body')}>
      <SkeletonLine width="70%" />
    </div>
  </div>
);

SkeletonComment.displayName = 'SkeletonComment';

export const SkeletonCommentContainer: FC = () => (
  <div
    className={cx('skeleton-comment__container')}
    data-qa="skeleton-comment__container"
  >
    <SkeletonComment />
    <SkeletonComment />
    <SkeletonComment />
  </div>
);

SkeletonCommentContainer.displayName = 'SkeletonCommentContainer';

export default {
  SkeletonLine,
  SkeletonComment,
  SkeletonCommentContainer,
};
